# frozen_string_literal: true

require_relative 'message'

module Engine
  module Action
    class Log < Message
    end
  end
end
